package com.merkost.handpass.api.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SuspendUserRequest(
    @SerialName("duration_days") val durationDays: Int,
    val reason: String? = null,
)
